import { getProfileRequest } from "api/auth";
import Loader from "components/shared/loader";
import PopoverProvider from "providers/PopoverProvider";
import PopupProvider from "providers/PopupProvider";
import { useEffect } from "react";
import { matchPath, Outlet, useLocation, useNavigate } from "react-router";
import { setSkinConfig } from "store/componentsSlice";
import { useAppDispatch } from "store/hooks";
import { getSkinConfigByUnivers } from "styles/skin";
import { APP_URL, getAppUrl } from "utils/defines";
import { getLocalStorageAccessToken } from "utils/helpers/localStorage";
import { useAuth } from "utils/hooks/useAuth";
import { useSalesNetwork } from "utils/hooks/useSalesNetworks";
import useTranslation from "utils/hooks/useTranslation";
import CookieBot from "react-cookiebot";
import { setEtudeId } from "store/etudeSlice";
import faviconAcv from "assets/icons/favicon-acv.ico";
import faviconDefault from "assets/icons/favicon.ico";
//import { DataLayerProvider } from "components/DataLayerProvider";
const favicon = document.querySelector("link[rel='icon']") as HTMLLinkElement;
const title = document.querySelector("title") as HTMLTitleElement;

const RootRoute: React.FC = () => {
  const { isAuth, setIsAuth, setProfile } = useAuth();
  const { setLanguage, language } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();

  const loginProcess = location.pathname.startsWith("/wso/callback");

  const { network, isLoading } = useSalesNetwork();

  const languages = network?.languages;

  const dispatch = useAppDispatch();

  useEffect(() => {
    if (network) {
      switch (network.code) {
        case "ACVFR":
          favicon.href = faviconAcv;
          title.text = "Proselect";
          break;
        default:
          favicon.href = faviconDefault;
          title.text = "ThermoDim";
      }
    }
  }, [network]);

  useEffect(() => {
    //todo review after changig routes
    const onPopState = (e: PopStateEvent) => {
      if ((window as any).IsInFormPage && (window as any).wasInSolutionsPage) {
        const state = e.state;
        const href = window.location.pathname + window.location.search;
        const cb = () => {
          window.removeEventListener("popstate", cb);
          setTimeout(() => navigate(href, { state }), 0);
        };
        window.addEventListener("popstate", cb);
        navigate(-1);
      }
      (window as any).wasInSolutionsPage = false;
    };
    window.addEventListener("popstate", onPopState);
    return () => {
      window.removeEventListener("popstate", onPopState);
    };
  }, []);

  useEffect(() => {
    const token = getLocalStorageAccessToken();

    if (token && network?.requiredConnexion) {
      setIsAuth(true);
      return;
    }

    if (
      !network ||
      isLoading ||
      location.pathname.endsWith("/template") ||
      loginProcess
    ) {
      return;
    }

    if (
      network.requiredConnexion &&
      location.pathname != getAppUrl(APP_URL.Login) &&
      !isAuth
    ) {
      navigate(getAppUrl(APP_URL.Login));
    }
  }, [
    isAuth,
    isLoading,
    location.pathname,
    loginProcess,
    navigate,
    network,
    setIsAuth,
  ]);

  useEffect(() => {
    if (isAuth && network?.id != undefined) {
      getProfileRequest(network?.id).then((res) => {
        setProfile(res.data);
      });
    }
  }, [isAuth, network?.id, setProfile]);

  useEffect(() => {
    if (languages && !language) {
      const storedLang = localStorage.getItem("language");
      if (storedLang && languages.find((l) => l.code === storedLang)) {
        setLanguage(storedLang);
      } else {
        setLanguage(
          languages.find((l) => l.isDefault)?.code || languages[0].code
        );
      }
    }
  }, [language, languages, setLanguage]);

  useEffect(() => {
    if (
      !matchPath(
        {
          path: `${APP_URL.Base}/${APP_URL.Etude}`,
          end: false,
        },
        location.pathname
      )
    ) {
      dispatch(setEtudeId(0));
    }
  }, [location.pathname]);

  useEffect(() => {
    if (network) {
      const brand: string =
        network?.brands.length > 1 ? "MULTI" : network?.brands[0].brand;

      dispatch(setSkinConfig(getSkinConfigByUnivers(brand || "")));
    }
  }, [dispatch, network]);

  return network ? (
    <>
      {/* <DataLayerProvider> */}
      {network && network.cookiebot && 1 > 2 && (
        <CookieBot domainGroupId={network.cookiebot} />
      )}
      <PopoverProvider>
        <PopupProvider>
          <Outlet />
        </PopupProvider>
      </PopoverProvider>
      {/* </DataLayerProvider> */}
    </>
  ) : (
    <>
      <Loader />
      <Outlet />
    </>
  );
};

export default RootRoute;
